import type { PlcManufacturerCodeLibrary } from "./types";

export const wagoCodeLibrary: PlcManufacturerCodeLibrary = {
  manufacturer_id: "wago",
  manufacturer_name: "WAGO",
  codes: [
    {
      id: "wago-profisafe-021e",
      manufacturer_id: "wago",
      series_id: "wago-pfc200",
      model: null,
      code: "0x021E",
      code_type: "PROFIsafe Diagnostic",
      title_ar: "Discrepancy time exceeded",
      description_ar: "ضمن منظومة WAGO PROFIsafe Generation 4، الكود 0x021E يعني أن زمن الـdiscrepancy تجاوز الحد.",
      symptoms: ["LED E أحمر", "0x021E"],
      causes: ["قناتين safety ما وصلن للحالة المتوقعة ضمن الزمن المحدد", "تأخير أو مشكلة بحساس/توصيل safety"],
      checks: [
        {
          step: 1,
          action: "افحص القناتين المرتبطات والـdiscrepancy time بدون تجاوز دائرة الأمان.",
          expected: "القناتين يتغيرن ضمن الزمن المحدد.",
          faulty: "يبقى فرق زمني ويتكرر 0x021E.",
        }
      ],
      solutions: ["عالج الحساس أو التوصيل المسبب للتأخير.", "لا تزيد زمن safety عشوائياً؛ راجع تقييم السلامة."],
      severity: "حرجة",
      source_title: "WAGO PROFIsafe Troubleshooting - Generation 4 - 50 LOGIC - BC - PFC",
      source_section: "Diagnosis message 0x021E Discrepancy time exceeded",
      keywords: ["WAGO", "PROFIsafe", "0x021E", "discrepancy"],
    },
    {
      id: "wago-profisafe-0250",
      manufacturer_id: "wago",
      series_id: "wago-pfc200",
      model: null,
      code: "0x0250",
      code_type: "PROFIsafe Diagnostic",
      title_ar: "Logic function error",
      description_ar: "الكود 0x0250 يعني Logic Function Error بوحدة الـsafety.",
      symptoms: ["LED E أحمر", "0x0250"],
      causes: ["خطأ بوظيفة logic داخل منظومة safety"],
      checks: [
        {
          step: 1,
          action: "اقرأ تشخيص الـsafety project والـmodule.",
          expected: "ماكو logic diagnostic active.",
          faulty: "يبقى 0x0250.",
        }
      ],
      solutions: ["راجع مشروع الـsafety والمنطق المرتبط.", "إذا الخطأ داخلي مستمر، اتبع تعليمات المصنع للصيانة/الاستبدال."],
      severity: "حرجة",
      source_title: "WAGO PROFIsafe Troubleshooting - Generation 4 - 50 LOGIC - BC - PFC",
      source_section: "Diagnosis message 0x0250 Logic function error",
      keywords: ["WAGO", "PROFIsafe", "0x0250", "logic function"],
    },
    {
      id: "wago-profisafe-0230",
      manufacturer_id: "wago",
      series_id: "wago-pfc200",
      model: null,
      code: "0x0230",
      code_type: "PROFIsafe Diagnostic",
      title_ar: "Overvoltage field supply",
      description_ar: "الكود 0x0230 يعني زيادة فولت بتغذية الـfield ضمن منظومة PROFIsafe.",
      symptoms: ["LED E أحمر", "0x0230"],
      causes: ["فولت field supply أعلى من المسموح"],
      checks: [
        {
          step: 1,
          action: "قِس تغذية الـfield بمعدة قياس مناسبة ومن شخص مؤهل.",
          expected: "الفولت ضمن مواصفات الوحدة.",
          faulty: "الفولت أعلى من المجال المسموح.",
        }
      ],
      solutions: ["صحح مصدر التغذية.", "لا ترجع دائرة safety للخدمة قبل زوال سبب الـovervoltage."],
      severity: "حرجة",
      source_title: "WAGO PROFIsafe Troubleshooting - Generation 4 - 50 LOGIC - BC - PFC",
      source_section: "Diagnosis message 0x0230 Overvoltage field supply",
      keywords: ["WAGO", "PROFIsafe", "0x0230", "overvoltage"],
    },  ],
};
